import { Component, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { FontType, stringFormat } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-postdate',
  shadow: false,
})
export class UgcReviewPostdate {
  @Prop() postedDateLocalized: string = '';
  @Prop() fontType: FontType = FontType.large;

  render() {
    const {
      reviewStaticLanguage: { IDS_TXT_POSTED_ON = '' },
      isDesktop,
    } = state;
    const fontType = this.fontType === FontType.large ? 'fs-14' : 'fs-12';
    if (isDesktop)
      return (
        <span class={`${fontType} lh-16 color-gray-500`}>
          {stringFormat(IDS_TXT_POSTED_ON, this.postedDateLocalized)}
        </span>
      );

    return <span class={`${fontType} lh-16 color-gray-500`}>{this.postedDateLocalized}</span>;
  }
}
